/**
 * `/tenants/new` — Link Admin tenant create wizard (LADM-02, Plan 06-03).
 *
 * Mounts the <CreateTenantWizard> 5-step flow. Breadcrumb labelKey points
 * at the link-admin namespace's `tenants.create.title` entry; the namespace
 * is already on the BREADCRUMB_NAMESPACES allow-list in
 * packages/design-system/src/patterns/Breadcrumbs/RouterBreadcrumbs.tsx so
 * the lazy-load race documented in project conventions §"Route breadcrumbs" doesn't
 * fire.
 */
import { createFileRoute } from "@tanstack/react-router";
import { CreateTenantWizard } from "../features/tenants/CreateTenantWizard";

export const Route = createFileRoute("/_auth/tenants/new")({
  staticData: {
    breadcrumb: { labelKey: "link-admin:tenants.create.title" },
  },
  component: CreateTenantWizard,
});
